// extracted by mini-css-extract-plugin
module.exports = {"age-limit-popup__icon":"style_age-limit-popup__icon__O4Zb8","age-limit-popup__description":"style_age-limit-popup__description__payiC"};